import api from '../../api';
// 获取视频列表
export function getMovieList(params) {
  return api.post('/movie/getMovieList.go', params, false, false).then(res => res);
}
// 新增视频
export function addMovie(params) {
  return api.post('/movie/addMovie.go', params, false, false).then(res => res);
}
// 展示视频
export function hideMovie(params) {
  return api.post('/movie/hideMovie.go', params).then(res => res);
}
// 删除视频
export function delMovie(params) {
  return api.post('/movie/delMovie.go', params).then(res => res);
}
// 修改视频
export function upMovie(params) {
  return api.post('/movie/upMovie.go', params).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/video.js